export default {
  labels: {
    username: 'Username',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    resetPassword: 'Reset Password',
  },
  placeholders: {
    username: 'Enter your username',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
  },
  buttons: {
    login: 'Login',
    save: 'Save',
  },
  title: {
    resetPassword: 'Reset Password',
  },
};
